import React from 'react';
import { DNABox, DNAButton, DNAText, DNACard, Iffy, DNASpinner } from '@alucio/lux-ui';
import { useUserTenant } from 'src/state/redux/selector/user';
import { useCrmStateMachine } from 'src/screens/Profile/CRMIntegration';
import withPermissionsAccessControl from 'src/hooks/useFeatureFlags/withPermissionsAccessControl';

const CRMLoginSection: React.FC = () => {
  const currentTenant = useUserTenant();
  const { cond, send, state } = useCrmStateMachine();

  const {
    isSyncing,
    isLoginUnavailable,
    isLoggedIn,
    isErrored,
    isLoginAttemptEnabled,
    loginButtonText,
    authErrorLabel,
  } = cond;
  const isLoading = isSyncing || state.context.isAuthenticating;

  if (isLoginUnavailable) {
    return null;
  }

  if (isLoggedIn && isSyncing) {
    return (
      <DNACard appearance="flat" style={{ margin: 24 }}>
        <DNABox appearance="col" spacing="md" alignX="center" alignY="center" style={{ paddingVertical: 48 }}>
          <DNASpinner />
          <DNAText bold status="subtle">Syncing CRM data...</DNAText>
        </DNABox>
      </DNACard>
    );
  }

  if (isLoggedIn) {
    return null;
  }

  const handleConnect = () => {
    send({
      type: 'LOGIN_CRM',
      payload: currentTenant?.config.crmIntegration,
    });
  };

  return (
    <DNACard appearance="flat" style={{ margin: 24 }}>
      <DNABox appearance="col" spacing="md" alignX="center" alignY="center" style={{ paddingVertical: 48 }}>
        <Iffy is={isLoading}>
          <DNASpinner />
          <DNAText bold status="subtle">Loading...</DNAText>
        </Iffy>

        <Iffy is={!isLoading}>
          <DNABox alignX="center">
            <DNAButton
              disabled={!isLoginAttemptEnabled}
              appearance={isLoading ? 'ghost' : 'filled'}
              status={isLoading ? 'tertiary' : 'primary'}
              onPress={handleConnect}
              size="lg"
            >
              {loginButtonText}
            </DNAButton>
          </DNABox>

          {/* Error Message */}
          <Iffy is={isErrored}>
            <DNABox appearance="col">
              <DNAText status="warning">
                {authErrorLabel}
              </DNAText>
            </DNABox>
          </Iffy>
        </Iffy>
      </DNABox>
    </DNACard>
  );
};

const CRMLoginSectionAccessControl = withPermissionsAccessControl(
  CRMLoginSection,
  { flags: ['enableCrmIntegration'] }
)

export default CRMLoginSectionAccessControl;
